import { Button, Card, Flex, Typography } from "antd"
import React, { type ReactNode } from "react"
import { useTranslation } from "react-i18next"

const { Title, Text } = Typography

interface NotAllowedProps {
  fallback?: ReactNode
  title?: string
  description?: string
  onBack?: () => void
}

export function NotAllowed({
  fallback,
  title,
  description,
  onBack
}: NotAllowedProps) {
  const { t } = useTranslation()

  if (fallback) {
    return (
      <div style={{ textAlign: "center", padding: "2rem" }}>{fallback}</div>
    )
  }

  return (
    <Card className={"w-full h-fit"}>
      <Flex
        vertical
        justify={"center"}
        align={"center"}
        style={{ textAlign: "center" }}
      >
        {/* Lock icon — pure SVG, no extra dep */}
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
          style={{ color: "var(--ant-color-text-quaternary, #bfbfbf)" }}
        >
          <rect
            x="5"
            y="11"
            width="14"
            height="10"
            rx="2"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            d="M8 11V7a4 4 0 0 1 8 0v4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <circle cx="12" cy="16" r="1.25" fill="currentColor" />
        </svg>

        <div>
          <Title level={5}>{title ?? t("notAllowed.title")}</Title>
          <Text type="secondary">
            {description ?? t("notAllowed.description")}
          </Text>
        </div>

        {onBack && (
          <Button size="small" onClick={onBack} style={{ marginTop: "0.5rem" }}>
            {t("notAllowed.goBack")}
          </Button>
        )}
      </Flex>
    </Card>
  )
}
